module.exports = __webpack_public_path__ + "BNFLogo.png?2c949310daa036e406a1b9fa9fd6aa6b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/BNFLogo.png
// module id = 587
// module chunks = 0